"use client";
import { useTranslations } from "next-intl";
import FAQSection from "@/components/shared/faq-section";

const IntegrationsFaq = () => {
  const t = useTranslations("integrations");
  const items = [0, 1, 2].map((i) => ({
    question: t(`faq.items.${i}.question`),
    answer: t(`faq.items.${i}.answer`),
  }));

  return <FAQSection title={t("faq.sectionTitle")} items={items} />;
};

export default IntegrationsFaq;
